import React from 'react';
import { observer } from 'mobx-react-lite';
import { TableLinkData } from 'entities/table/model/tableLinkModel';
import TableCellItem from 'shared/lib/extendedComponents/tables/editableTable/editableTableCellItem';
import IconCross from 'shared/icons/cross';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default observer(function EditableTableRow({
  item,
  onDelete,
  isDeleteDisabled = false,
  shouldHighlightValidation,
}: {
  item: TableLinkData;
  onDelete: () => void;
  isDeleteDisabled?: boolean;
  shouldHighlightValidation?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <tr>
      <td className="vertical">
        <TableCellItem
          value={item.name}
          isEditIcon={!item.name}
          placeholder={t('formFields.projectName')}
          onChange={(e) => {
            if (item) {
              item.name = e.target.value;
            }
          }}
          error={!item.name && shouldHighlightValidation}
        ></TableCellItem>
      </td>
      <td className="vertical">
        <TableCellItem
          value={item.description}
          isEditIcon={!item.description}
          placeholder={t('formFields.description')}
          onChange={(e) => {
            if (item) {
              item.description = e.target.value;
            }
          }}
          error={!item.description && shouldHighlightValidation}
        ></TableCellItem>
      </td>
      <td className="vertical">
        <TableCellItem
          value={item.url}
          isEditIcon={!item.url}
          placeholder={t('formFields.link')}
          onChange={(e) => {
            if (item) {
              item.url = e.target.value.replace(/(\r\n|\n|\r)/gm, '');
            }
          }}
          textColor="primary.main"
          error={!item.url && shouldHighlightValidation}
          inputProps={{
            style: {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
          }}
          multiline={false}
        ></TableCellItem>
      </td>
      {isDeleteDisabled ? (
        <td className="deleteRowTd">
          <Box
            sx={{
              opacity: 0,
            }}
          >
            <IconCross sizeKey="18x18"></IconCross>
          </Box>
        </td>
      ) : (
        <td className="deleteRowTd" onClick={onDelete}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
          >
            <IconCross sizeKey="18x18"></IconCross>
          </Box>
        </td>
      )}
    </tr>
  );
});
